<template>
  <div>
    <!-- Utiliza a prop "data" (que aqui mapeamos para datacollection) -->
    <Bar :data="datacollection" :options="chartOptions" />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    datacollection: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: true,
            text: 'Evolução Carteira'
          }
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Mês'
            }
          },
          y: {
            title: {
              display: true,
              text: 'Valores'
            },
            beginAtZero: true
          }
        }
      }
    }
  },
  watch: {
    datacollection: {
      handler(newVal) {
        // Se necessário, podemos reagir a mudanças no datacollection aqui.
      },
      deep: true
    }
  }
}
</script>

<style scoped>
div {
  position: relative;
  height: 400px;
}
</style>
